import Constants from '@/utils/Constants';
import Logger from '@/utils/Logger';

// @ts-nocheck
export default class MiApiWrapper {

  private _playerId: string;
  private _playerContainerId: string;
  private _videoId: string;
  private _lastVideoId: string | undefined = undefined;
  private _switchingVideo = false;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  private _playerApi: undefined | any;
  private _onPlayHandlerAdded = false;
  private _justSwitchedVideo = false;

  private _playerAttributes: Record<string, string> = {
    'mi24-video-player': '',
    'disable-auto-creation': '',
    'configType': 'vmpro',
    'apiUrl': Constants.miEmbededPlayerApiUrl
  };

  constructor(playerContainerId: string, playerId: string, videoId: string) {
    this._playerId = playerId;
    this._playerContainerId = playerContainerId;
    this._videoId = videoId;
    this._playerAttributes['videoId'] = videoId;
    this._playerAttributes['playerId'] = playerId;
  }

  public async initPlayer(): Promise<void> {
    try {
      await this.addPlayer([10, 100, 500, 1000, 3000, 5000, 10000]);
    }
    catch(error) {
      Logger.warn(`Failed to init player, ${error}.`);
    }
  }

  public async deletePlayer(): Promise<void> {
    try {
      await this.removePlayer();
    }
    catch(error) {
      Logger.debug(`Failure while trying to delete the player, ${error}.`);
    }
  }

  public async switchVideo(videoId: string) {

    if(this._switchingVideo) {
      return;
    }

    try {
      this._switchingVideo = true;

      if(this._lastVideoId != videoId) {
        this._lastVideoId = videoId;
        this._videoId = videoId;

        await this.switchVideoMi(videoId);
      }
    }
    finally {
      this._switchingVideo = false;
    }
  }

  public get playerId(): string {
    return this._playerId;
  }
  public get videoId(): string {
    return this._videoId;
  }
  
  public get playerApi() {
    return this._playerApi;
  }
  public get playerContainerId(): string {
    return this._playerContainerId;
  }

  private async sleep(ms: number) {
    await new Promise(r => setTimeout(r, ms));
  }

  private async addPlayer(retries?: Array<number>): Promise<void> {

    retries = retries ? retries : [0];
    let lastError: undefined|unknown = undefined;

    for(const waitTime of retries) {
      try {
        await new Promise<void>((resolve, reject) => {
          try {
    
            this._playerAttributes['videoId'] = this.videoId;
            this._playerAttributes['playerId'] = this.playerId;
    
            this.miApi.addPlayerById(this.playerContainerId, {
              /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
              success: (playerApi: any) => {
                this._playerApi = playerApi;
                this._onPlayHandlerAdded = false;
                this._justSwitchedVideo = false;
                resolve();
              },
              parameters: this._playerAttributes
            });
          }
          catch(error) {
            lastError = error;
            reject(error);
          }
        });
        return; //success
      }
      catch(error) {
        await this.sleep(waitTime);
      }
    }
    throw lastError;
  }

  private async removePlayer(retryCount?: number) {

    // in some cases, for whatever reasons, the removing of the player fails.
    // as a workaround, we try a certain amount of times until we either succeed finally give up.

    if(!retryCount || retryCount <= 0) retryCount = 1;
    for(let i = 0; i < retryCount; ++i) {
      try {
        this._playerApi = undefined;
        this.miApi.removePlayerById(this.playerContainerId);
        break;
      }
      catch(error) {
        if(i < retryCount - 1) await this.sleep(20);
        else {
          throw error;
        }
      }
    }
  }


  private async switchVideoMi(videoId: string) {

    // switching video does not work the same on mobile and desktop players.
    // there are various 'hacks' needed to makes this work properly.

    try {
      if(this._playerApi) {
        
        const isMobilePlayer = <HTMLElement>document.querySelector(`#${this._playerContainerId} .mi-player.mi-non-mobile`) == null;
        if(isMobilePlayer) {
          await this._playerApi.stop();
        }
        await this._playerApi.switchVideo(videoId);

        
        console.log("isMobilePlayer", isMobilePlayer);
        if(isMobilePlayer) {
          setTimeout(() => {
            const bigPlayButton = <HTMLElement>document.querySelector(`#${this._playerContainerId} .mi-big-play.big-play-button`);
            if(bigPlayButton) {
              bigPlayButton.style.display = 'block';
              bigPlayButton.style.visibility = 'visible'
            }
          }, 200);
        }
        
        this._justSwitchedVideo = true;
        // hint: when switching videos, we don't want the video to autoplay. This is a workaround to make this behavior work for non mobile players.
        if(!isMobilePlayer) {
          if(!this._onPlayHandlerAdded) {
            this._onPlayHandlerAdded = true;

            this._playerApi.registerEventListener('play', async () => {
              
              // Display the big blay button on pause.
              const bigPlayButton = <HTMLElement>document.querySelector(`#${this._playerContainerId} .mi-big-play.big-play-button`);

              if(this._justSwitchedVideo) {
                await this._playerApi.pause();
                this._justSwitchedVideo = false;
                
                if(bigPlayButton) {
                  bigPlayButton.style.display = 'block';
                  bigPlayButton.style.visibility = 'visible'
                }
              }
              else {
                if(bigPlayButton) {
                  bigPlayButton.style.display = 'none';
                  bigPlayButton.style.visibility = 'hidden'
                }
              }
            });
          }
        }
      }
    }
    catch(error) {
      Logger.error(`switchVideoMi (${videoId}): Failed to switch video. '${error}'`);
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  private get miApi(): any {
    //@ts-ignore
    if(window && window.VideoPlayer && window.VideoPlayer.Collection) {
      //@ts-ignore
      return window.VideoPlayer.Collection;
    }
    else {
      throw new Error(`Moving image API not available.`);
    }
  }

}
